import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vup8x6ncrs: FaireBrandEntity = {
  token: "b_vup8x6ncrs",
  type: "brand",
  name: "Studio Conroy",
  avatarUrl:
    "https://cdn.faire.com/fastly/0a1e280e5fef6c6c2890a9872fceffcb12559bfdd9d97865753f0ad38630948c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9159ecee03b86c2ab60758c1888c139412e13127ff3b6c5c9d1fb345af21a8e9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0a1e280e5fef6c6c2890a9872fceffcb12559bfdd9d97865753f0ad38630948c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9159ecee03b86c2ab60758c1888c139412e13127ff3b6c5c9d1fb345af21a8e9.png",
  location: "Venice, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "I'm Emma Conroy, self taught illustrator and graphic designer. As a lifelong doodler, Studio Conroy was born from my need to create. With a vintage-inspired aesthetic, my designs are cheeky, delicate, and playful. I love a pun, a little flower, and never met a scalloped frame I didn't like.\n\nWhen I'm not working out of my home studio in Venice, California, I love thrifting, watching reality tv, and visiting cozy coffee shops! ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:20.138Z",
    importedBy: "entity-db-cli",
  },
};
